import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription, timer } from 'rxjs';
import { repeat, flatMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-app-withdraw-table-individual-info',
  templateUrl: './app-withdraw-table-individual-info.component.html',
  styleUrls: ['./app-withdraw-table-individual-info.component.scss'],
  standalone: false,
})
export class AppWithdrawTableIndividualInfoComponent implements OnInit, OnDestroy {
  data?: AutoWithdrawConfigDTO[];

  private subscription: Subscription;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.subscription = timer(0, 20000)
      .pipe(
        repeat(),
        flatMap(() => this.http.get<AutoWithdrawConfigDTO[]>('/auto-withdrawals-config/active-cohorts')),
        tap((d) => (this.data = d))
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}

export interface AutoWithdrawConfigDTO {
  requestToPendingEnabled: boolean;
  requestedToPendingInMinutes: number;
  pendingToAcceptedEnabled: boolean;
  pendingToAcceptedInMinutes: number;
  cohortId: number;
  cohortIcon: string;
  cohortCode: string;
}
